import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { searchBox } from '../../../styles/DefinitionSubspaceSharedStyles';

const testId = 'definition-subspace-values-toolbar';

export interface DefinitionSubspaceValuesControlsProps {
  searchText: string;
  onChangeSearch: (searchText: string) => void;
}

export const DefinitionSubspaceValuesControls = (props: DefinitionSubspaceValuesControlsProps) => {

  return <TextFieldWidget
    className={searchBox}
    kind={'search'}
    label={undefined}
    onChange={e => props.onChangeSearch(e.target.value)}
    onClear={() => props.onChangeSearch('')}
    value={props.searchText}
    testId={testId}
    placeholder={Messages.dataRoleDefinitionSubspace_Values_SearchValues()}/>;
};
